import { HeaderContext } from "@tanstack/react-table";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";

export default function ExpansionHeader<RowType>(
  props: HeaderContext<RowType, any>
) {
  const {
    table: { toggleAllRowsExpanded, getIsAllRowsExpanded },
  } = props;

  return (
    <div
      className="cursor-pointer select-none"
      onClick={() => toggleAllRowsExpanded()}
    >
      <ChevronDown
        size="16"
        className={clsx("transition-transform duration-300", {
          "rotate-180": getIsAllRowsExpanded(),
        })}
      />
    </div>
  );
}
